import React from 'react';

export const GameDevelopment: React.FC = () => {
  return (
    <svg width="98" height="70" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M96.8991 55.45L91.4491 17.15C90.0491 7.3 81.5991 0 71.6491 0H26.3491C16.3991 0 7.9491 7.3 6.5491 17.15L1.0991 55.45C-0.000894904 63.15 5.9491 70 13.6991 70C17.0991 70 20.2991 68.65 22.6991 66.25L33.9991 55H63.9991L75.2491 66.25C77.6491 68.65 80.8991 70 84.2491 70C92.0491 70 97.9991 63.15 96.8991 55.45ZM43.9991 30H33.9991V40H28.9991V30H18.9991V25H28.9991V15H33.9991V25H43.9991V30ZM63.9991 25C61.2491 25 58.9991 22.75 58.9991 20C58.9991 17.25 61.2491 15 63.9991 15C66.7491 15 68.9991 17.25 68.9991 20C68.9991 22.75 66.7491 25 63.9991 25ZM73.9991 40C71.2491 40 68.9991 37.75 68.9991 35C68.9991 32.25 71.2491 30 73.9991 30C76.7491 30 78.9991 32.25 78.9991 35C78.9991 37.75 76.7491 40 73.9991 40Z"
        fill="#199EC6"
      />
    </svg>
  );
};

export const SoundDesign: React.FC = () => {
  return (
    <svg
      width="80"
      height="100"
      viewBox="0 0 80 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 100H50V0H30V100ZM0 100H20V50H0V100ZM60 31.25V100H80V31.25H60Z"
        fill="#199EC6"
      />
    </svg>
  );
};

export const CharacterCreation: React.FC = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.5414 1.95604C58.5414 -4.88143 42.3821 8.29318 40.9681 9.6796C27.2302 12.9 16.1855 23.0378 11.7734 36.1837C-5.40523 31.2704 -2.74945 69.6975 13.0391 64.9789C15.8811 71.4807 20.3984 77.094 26.0504 81.2826C22.0008 84.537 16.6709 90.6049 16.6709 100H84.0267C84.0267 90.6048 78.6966 84.5368 74.6469 81.2824C80.2988 77.0939 84.8159 71.4807 87.6579 64.979C104.345 66.8429 103.46 33.4663 88.9237 36.1839C84.5118 23.0382 73.4675 12.9004 59.73 9.67982C59.724 9.67397 59.6963 9.66436 59.6515 9.64876C59.0925 9.45446 55.8599 8.33083 58.5414 1.95604ZM75.8004 46.6412C73.0089 47.744 70.5228 48.9862 68.3599 50.0669C61.6938 53.3978 58.0989 55.1941 58.0989 46.6412C58.0989 41.7903 62.0615 37.8579 66.9497 37.8579C71.8378 37.8579 75.8004 41.7903 75.8004 46.6412ZM32.5703 50.0669C30.4075 48.9862 27.9213 47.744 25.1298 46.6412C25.1298 41.7903 29.0924 37.8579 33.9806 37.8579C38.8687 37.8579 42.8313 41.7903 42.8313 46.6412C42.8313 55.1941 39.2364 53.3978 32.5703 50.0669Z"
        fill="#199EC6"
      />
    </svg>
  );
};

export const Model3d: React.FC = () => {
  return (
    <svg
      width="133"
      height="107"
      viewBox="0 0 133 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.1547 3C66.9828 3 67.6547 2.32843 67.6547 1.5C67.6547 0.671574 66.9828 0 66.1547 0C65.3265 0 64.6547 0.671574 64.6547 1.5C64.6547 2.32843 65.3265 3 66.1547 3Z"
        fill="#199EC6"
      />
      <path
        d="M67.6547 8.5C67.6547 9.32843 66.9828 10 66.1547 10C65.3265 10 64.6547 9.32843 64.6547 8.5C64.6547 7.67157 65.3265 7 66.1547 7C66.9828 7 67.6547 7.67157 67.6547 8.5Z"
        fill="#199EC6"
      />
      <path
        d="M67.6547 15.5C67.6547 16.3284 66.9828 17 66.1547 17C65.3265 17 64.6547 16.3284 64.6547 15.5C64.6547 14.6716 65.3265 14 66.1547 14C66.9828 14 67.6547 14.6716 67.6547 15.5Z"
        fill="#199EC6"
      />
      <path
        d="M67.6547 22.5C67.6547 23.3284 66.9828 24 66.1547 24C65.3265 24 64.6547 23.3284 64.6547 22.5C64.6547 21.6716 65.3265 21 66.1547 21C66.9828 21 67.6547 21.6716 67.6547 22.5Z"
        fill="#199EC6"
      />
      <path
        d="M100.73 43.8264C102.448 43.1632 102.433 40.7275 100.706 40.0859L66.2035 27.26C65.7523 27.0923 65.2562 27.0929 64.805 27.2618L30.5609 40.0876C28.8412 40.7317 28.8265 43.1588 30.5375 43.8245L64.7826 57.1436C65.2465 57.3244 65.7621 57.325 66.2269 57.1455L100.73 43.8264Z"
        fill="#199EC6"
      />
      <path
        d="M25.6547 50.2722C25.6547 48.8938 27.016 47.9285 28.3168 48.3852L62.0951 60.243C62.8959 60.5243 63.432 61.281 63.432 62.1301V104.029C63.432 105.448 61.9945 106.416 60.68 105.882L26.9017 92.1589C26.1478 91.8526 25.6547 91.1198 25.6547 90.306V50.2722Z"
        fill="#199EC6"
      />
      <path
        d="M102.993 48.3852C104.293 47.9285 105.655 48.8938 105.655 50.2722V90.306C105.655 91.1198 105.161 91.8526 104.408 92.1589L70.6293 105.882C69.3148 106.416 67.8773 105.448 67.8773 104.029V62.1301C67.8773 61.281 68.4134 60.5243 69.2142 60.243L102.993 48.3852Z"
        fill="#199EC6"
      />
      <path
        d="M111.856 93.0302C112.078 92.2321 111.61 91.4052 110.811 91.1839C110.013 90.9625 109.186 91.4304 108.965 92.2284C108.744 93.0264 109.211 93.8534 110.009 94.0747C110.808 94.2961 111.634 93.8282 111.856 93.0302Z"
        fill="#199EC6"
      />
      <path
        d="M118.601 94.9008C118.823 94.1028 118.355 93.2759 117.557 93.0545C116.758 92.8331 115.932 93.3011 115.71 94.0991C115.489 94.8971 115.956 95.724 116.755 95.9454C117.553 96.1668 118.38 95.6988 118.601 94.9008Z"
        fill="#199EC6"
      />
      <path
        d="M125.347 96.7715C125.568 95.9735 125.1 95.1466 124.302 94.9252C123.504 94.7038 122.677 95.1718 122.455 95.9698C122.235 96.7678 122.703 97.5947 123.5 97.8161C124.299 98.0375 125.125 97.5695 125.347 96.7715Z"
        fill="#199EC6"
      />
      <path
        d="M131.047 96.7959C131.846 97.0172 132.314 97.8442 132.092 98.6422C131.87 99.4402 131.044 99.9081 130.245 99.6867C129.448 99.4654 128.98 98.6385 129.202 97.8404C129.422 97.0424 130.249 96.5745 131.047 96.7959Z"
        fill="#199EC6"
      />
      <path
        d="M21.3363 91.1839C20.5375 91.4052 20.0697 92.2321 20.2914 93.0302C20.5131 93.8282 21.3392 94.2961 22.1381 94.0747C22.9359 93.8534 23.4037 93.0264 23.182 92.2284C22.9613 91.4304 22.1341 90.9625 21.3363 91.1839Z"
        fill="#199EC6"
      />
      <path
        d="M14.5902 93.0545C13.7924 93.2759 13.3246 94.1028 13.5463 94.9008C13.767 95.6988 14.5941 96.1668 15.392 95.9454C16.1908 95.724 16.6586 94.8971 16.4369 94.0991C16.2152 93.3011 15.389 92.8331 14.5902 93.0545Z"
        fill="#199EC6"
      />
      <path
        d="M7.84509 94.9252C7.04724 95.1466 6.57946 95.9735 6.80017 96.7715C7.02185 97.5695 7.84802 98.0375 8.64685 97.8161C9.4447 97.5947 9.91247 96.7678 9.69177 95.9698C9.47009 95.1718 8.64294 94.7038 7.84509 94.9252Z"
        fill="#199EC6"
      />
      <path
        d="M0.0550486 98.6422C-0.166631 97.8442 0.301142 97.0172 1.09997 96.7959C1.89782 96.5745 2.72497 97.0424 2.94567 97.8404C3.16735 98.6385 2.69958 99.4654 1.90173 99.6867C1.1029 99.9081 0.276728 99.4402 0.0550486 98.6422Z"
        fill="#199EC6"
      />
    </svg>
  );
};
